import { render, staticRenderFns } from "./NpsType.vue?vue&type=template&id=962a9e18&scoped=true&"
import script from "./NpsType.vue?vue&type=script&lang=js&"
export * from "./NpsType.vue?vue&type=script&lang=js&"
import style0 from "./NpsType.vue?vue&type=style&index=0&id=962a9e18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962a9e18",
  null
  
)

export default component.exports